import { IclickEffectSet, ImouseEffectSet } from '@typings/setting/mouseSet.interface';
import { atom } from 'recoil';

export const mouseEffectState = atom<ImouseEffectSet>({
  key: 'mouseEffectState',
  default: {
    isActive: false,
    shape: 'heart',
    direction: 'goUp',
    color: '#000',
    minSize: 14,
    number: 66,
  },
});

export const clickEffectState = atom<IclickEffectSet>({
  key: 'clickEffectState',
  default: {
    isActive: false,
    type: 'particle',
    color: '#000',
    color2: '#000',
    size: 14,
    duration: 1000,
  },
});
